module.exports = __webpack_public_path__ + "assets/bus.ac514ea20f5ce2782a9c0ea598c23374.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bus.jpg
// module id = 624
// module chunks = 0